import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VuePlyr from 'vue-plyr'
import VTooltip from 'v-tooltip'
import VueQrcode from '@chenfengyuan/vue-qrcode'

// We unfortunatly need jQuery for our gauge to work properly
require("expose-loader?$!jquery")
require("expose-loader?roundSlider!round-slider")


Vue.use(VTooltip, {
  defaultBoundariesElement: 'window',
});

// The second argument is optional and sets the default config values for every player.
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: true },
    autoplay: true
  },
  emit: ['ended']
})

Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
